import { BarChart3, Dumbbell } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { to: '/workouts', label: 'Тренировки', icon: Dumbbell },
  { to: '/progress', label: 'Прогресс', icon: BarChart3 }
];

export function AppShell() {
  return (
    <div className="app-shell">
      <div className="app-content"><Outlet /></div>
      <nav className="tab-bar" aria-label="Основные разделы">
        <div className="tab-bar-inner">
          {tabs.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} className={({ isActive }) => `tab-item${isActive ? ' is-active' : ''}`}>
              <Icon aria-hidden="true" size={25} strokeWidth={2.2} />
              <span>{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}

export default AppShell;
